<template>
  <div id="ESG">
    <Header />
    <div id="container">
      <BreadCrumb />
      <div id="contents" class="contents">
        <div class="sub_header bg_esg01">
          <h3 class="title title_esg">사회적가치(ESG)</h3>
          <p class="txt txt_esg">
            SK텔링크는 ESG(환경·사회·지배구조)<br />경영을 선도하는 기업입니다.
          </p>
          <img
            src="/content/images/sub_header_bg_esg01_mo.jpg"
            alt="비쥬얼 이미지"
          />
        </div>

        <div class="company esg">
          <div class="cp_area pb0">
            <div class="cp_box">
              <h4>ESG 개요</h4>
              <p>
                SK텔링크는 전사적 차원에서 ESG 경영의 추진 방향을 설정하고
                지속가능성을 강화하기 위해 노력하고 있습니다.
              </p>
            </div>
          </div>

          <div class="esg_box">
            <div class="scroll_area">
              <div class="inner">
                <img
                  src="/content/images/20220512_esg_img.png"
                  alt="친환경 ICT로 진화, ICT의 사화적 가치 창출, 책임경영/투명경영 강화"
                />
              </div>
            </div>
            <p class="table_note" style="text-align: center">
              ※ 당사는 관계기업·공동기업 등 연결실체에 포함되지 않는 피투자자를
              보유하고 있지 않습니다.
            </p>
            <div class="ui-btn-wrap">
              <a class="ui-btn" @click="isVisibleFn()">
                ESG 경영개선 공시자료
              </a>
              <a
                class="ui-btn"
                href="/content/pdf/Final_SK_KR_ESG_2026_v1.pdf"
                target="_blank"
                >제 3자 검증 성명서</a
              >
            </div>
          </div>
        </div>
        <!-- company -->
        <div v-if="isVisibleData">
          <div id="tabTarget" class="tab_type01">
            <ul>
              <li :class="tabIndex == 1 ? 'on' : ''">
                <a
                  :title="tabIndex == 1 ? '현재메뉴 선택됨' : ''"
                  @click="tabActive(1)"
                  >사회 데이터</a
                >
              </li>
              <li :class="tabIndex == 2 ? 'on' : ''">
                <a
                  :title="tabIndex == 2 ? '현재메뉴 선택됨' : ''"
                  @click="tabActive(2)"
                  >환경 데이터</a
                >
              </li>
            </ul>
          </div>

          <div class="company esg">
            <div v-if="tabIndex == 1">
              <div class="esg_box">
                <h4>구성원 일반 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      구성원 일반 현황
                    </caption>
                    <colgroup>
                      <col style="width: 14%" />
                      <col style="width: 14%" />
                      <col style="width: 14%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="3">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="5">
                          인원<br class="mobile-only" />
                          현황
                        </td>
                        <td rowspan="3">
                          전체<br class="mobile-only" />
                          인력
                        </td>
                        <td>계</td>
                        <td>명</td>
                        <td>162</td>
                        <td>162</td>
                        <td>146</td>
                      </tr>
                      <tr>
                        <td>국내</td>
                        <td>명</td>
                        <td>162</td>
                        <td>162</td>
                        <td>146</td>
                      </tr>
                      <tr>
                        <td>해외</td>
                        <td>명</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td colspan="2">정규직 고용</td>
                        <td>명</td>
                        <td>159</td>
                        <td>157</td>
                        <td>141</td>
                      </tr>
                      <tr>
                        <td colspan="2">비정규직 고용</td>
                        <td>명</td>
                        <td>3</td>
                        <td>5</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td rowspan="2">성별</td>
                        <td colspan="2">여성 전체</td>
                        <td>명</td>
                        <td>36</td>
                        <td>35</td>
                        <td>33</td>
                      </tr>
                      <tr>
                        <td colspan="2">여성인력 비율</td>
                        <td>%</td>
                        <td>22</td>
                        <td>22</td>
                        <td>23</td>
                      </tr>
                      <tr>
                        <td>
                          장애인<br class="mobile-only" />
                          고용
                        </td>
                        <td colspan="2">장애인 고용 전체</td>
                        <td>명</td>
                        <td>2</td>
                        <td>2</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td rowspan="6">신규<br class="mobile-only" />채용</td>
                        <td colspan="2">
                          전체<br class="mobile-only" />(정규+비정규)
                        </td>
                        <td>명</td>
                        <td>14</td>
                        <td>3</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td colspan="2">정규직</td>
                        <td>명</td>
                        <td>13</td>
                        <td>2</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td colspan="2">비정규직</td>
                        <td>명</td>
                        <td>1</td>
                        <td>1</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td rowspan="3">총계</td>
                        <td>여성</td>
                        <td>명</td>
                        <td>7</td>
                        <td>1</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>남성</td>
                        <td>명</td>
                        <td>7</td>
                        <td>2</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td>여성<br class="mobile-only" />비율</td>
                        <td>%</td>
                        <td>50</td>
                        <td>33</td>
                        <td>25</td>
                      </tr>
                      <tr>
                        <td rowspan="3">퇴직</td>
                        <td>총 퇴직자 수</td>
                        <td>전체</td>
                        <td>명</td>
                        <td>4</td>
                        <td>4</td>
                        <td>22</td>
                      </tr>
                      <tr>
                        <td colspan="2">총 퇴직율</td>
                        <td>%</td>
                        <td>2</td>
                        <td>2</td>
                        <td>15</td>
                      </tr>
                      <tr>
                        <td colspan="2">자발적 퇴직율</td>
                        <td>%</td>
                        <td>2</td>
                        <td>1</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td colspan="3">육아휴직 복귀율</td>
                        <td>%</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>구성원 교육 및 평가 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      구성원 교육 및 평가 현황
                    </caption>
                    <colgroup>
                      <col style="width: 21%" />
                      <col style="width: 21%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="2">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">
                          교육<br class="mobile-only" />투자비용
                        </td>
                        <td>투자비용</td>
                        <td>백만원</td>
                        <td>497</td>
                        <td>484</td>
                        <td>443</td>
                      </tr>
                      <tr>
                        <td>
                          인당<br class="mobile-only" />
                          교육 비용
                        </td>
                        <td>백만원</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td>교육 시간</td>
                        <td>
                          인당<br class="mobile-only" />
                          연평균<br class="mobile-only" />
                          교육시간
                        </td>
                        <td>시간</td>
                        <td>71</td>
                        <td>77</td>
                        <td>58</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>안전 보건 관리 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      안전 보건 관리 현황
                    </caption>
                    <colgroup>
                      <col style="width: 21%" />
                      <col style="width: 21%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="2">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>재해율</td>
                        <td>재해율</td>
                        <td>%</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>기업 데이터 및 고객 정보 보호 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      기업 데이터 및 고객 정보 보호 현황
                    </caption>
                    <colgroup>
                      <col style="width: 21%" />
                      <col style="width: 21%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="2">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">
                          개인정보,<br class="mobile-only" />
                          사이버보안<br class="mobile-only" />
                          교육현황
                        </td>
                        <td>교육 대상자</td>
                        <td>명</td>
                        <td>159</td>
                        <td>164</td>
                        <td>162</td>
                      </tr>
                      <tr>
                        <td>교육 이수율</td>
                        <td>%</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td rowspan="3">
                          정보보안<br class="mobile-only" />
                          침해
                        </td>
                        <td>
                          고객 정보<br class="mobile-only" />
                          유출
                        </td>
                        <td>건</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>
                          시스템 해킹
                        </td>
                        <td>건</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>
                          DDos 침해
                        </td>
                        <td>건</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>ESG 활동</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      ESG 활동
                    </caption>
                    <colgroup>
                      <col style="width: 42%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          사회공헌 비용
                        </td>
                        <td>백만원</td>
                        <td>2</td>
                        <td>10</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>협력사 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      협력사 현황
                    </caption>
                    <colgroup>
                      <col style="width: 21%" />
                      <col style="width: 21%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="2">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">협력업체 수</td>
                        <td>총 공급업체 수</td>
                        <td>개</td>
                        <td>39</td>
                        <td>40</td>
                        <td>42</td>
                      </tr>
                      <tr>
                        <td>중요 공급업체 수</td>
                        <td>개</td>
                        <td>11</td>
                        <td>11</td>
                        <td>11</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="esg_box">
                <h4>윤리경영 현황 관리</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      윤리경영 현황 관리
                    </caption>
                    <colgroup>
                      <col style="width: 42%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>윤리경영<br class="mobile-only" />
                          온라인 교육<br class="mobile-only" />
                          이수율</td>
                        <td>%</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>윤리경영<br class="mobile-only" />
                          토론식 심화<br class="mobile-only" />
                          교육 (오프라인)<br class="mobile-only" />
                          참여율</td>
                        <td>%</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>성희롱예방<br class="mobile-only" />
                          온라인 교육<br class="mobile-only" />
                          이수율</td>
                        <td>%</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>윤리상담센터/<br class="mobile-only" />
                          윤리 상담 및<br class="mobile-only" />
                          제보 건수</td>
                        <td>건</td>
                        <td>6</td>
                        <td>5</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>윤리상담센터/<br class="mobile-only" />
                          윤리 상담 및<br class="mobile-only" />
                          제보 처리완료<br class="mobile-only" />
                          건수</td>
                        <td>건</td>
                        <td>6</td>
                        <td>5</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>윤리규정 위반에<br class="mobile-only" />
                          따른 조치<br class="mobile-only" />
                          _품위손상</td>
                        <td>건</td>
                        <td>-</td>
                        <td>1</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>윤리규정 위반에<br class="mobile-only" />
                          따른 조치<br class="mobile-only" />
                          _관리책임</td>
                        <td>건</td>
                        <td>-</td>
                        <td>-</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>윤리규정 위반에<br class="mobile-only" />
                          따른 조치<br class="mobile-only" />
                          _기타 비윤리 행위</td>
                        <td>건</td>
                        <td>-</td>
                        <td>-</td>
                        <td>2</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-if="tabIndex == 2">
              <div class="esg_box">
                <h4>온실가스 배출량 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      온실가스 배출량 현황
                    </caption>
                    <colgroup>
                      <col style="width: 21%" />
                      <col style="width: 21%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="2">&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="3">
                          온실가스<br class="mobile-only" />
                          총 배출량
                        </td>
                        <td>총량</td>
                        <td>tonCO<sub>2</sub>e</td>
                        <td>2,335</td>
                        <td>2,333</td>
                        <td>2,257</td>
                      </tr>
                      <tr>
                        <td>
                          직접<br class="mobile-only" />
                          온실가스<br class="mobile-only" />
                          배출량
                        </td>
                        <td>tonCO<sub>2</sub>e</td>
                        <td>103</td>
                        <td>102</td>
                        <td>93</td>
                      </tr>
                      <tr>
                        <td>
                          간접<br class="mobile-only" />
                          온실가스<br class="mobile-only" />
                          배출량
                        </td>
                        <td>tonCO<sub>2</sub>e</td>
                        <td>2,230</td>
                        <td>2,230</td>
                        <td>2,163</td>
                      </tr>
                      <tr>
                        <td rowspan="3">
                          에너지<br class="mobile-only" />
                          소비량
                        </td>
                        <td>총량</td>
                        <td>GJ</td>
                        <td>48,281</td>
                        <td>48,303</td>
                        <td>46,794</td>
                      </tr>
                      <tr>
                        <td>
                          직접<br class="mobile-only" />
                          에너지<br class="mobile-only" />
                          소비량
                        </td>
                        <td>GJ</td>
                        <td>1,678</td>
                        <td>1,700</td>
                        <td>1,587</td>
                      </tr>
                      <tr>
                        <td>
                          간접<br class="mobile-only" />
                          에너지<br class="mobile-only" />
                          소비량
                        </td>
                        <td>GJ</td>
                        <td>46,603</td>
                        <td>46,603</td>
                        <td>45,207</td>
                      </tr>
                      <tr>
                        <td rowspan="3">
                          재생
                          <br class="mobile-only" />
                          에너지
                        </td>
                        <td>
                          재생가능한 에너지 <br class="mobile-only" />총 사용량
                        </td>
                        <td>MWh</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="table_note">
                  ※ 2025년 배출량은 DNV의 제3자 검증(2026년 6월)을 받은
                  수치입니다. 당사는 별도의 정량 감축 목표 없이 모회사
                  SK텔레콤의 Net Zero 목표에 동참하여 연간 배출량 추이를
                  관리하고 있습니다.
                </p>
              </div>

              <div class="esg_box">
                <h4>용수 및 폐기물 현황</h4>
                <div class="table_type04">
                  <table>
                    <caption>
                      용수 및 폐기물 현황
                    </caption>
                    <colgroup>
                      <col style="width: 42%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>단위</th>
                        <th>2023</th>
                        <th>2024</th>
                        <th>2025</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>용수 사용량</td>
                        <td>Ton</td>
                        <td>65,810</td>
                        <td>77,285</td>
                        <td>61,434</td>
                      </tr>
                      <tr>
                        <td>생활폐기물</td>
                        <td>Ton</td>
                        <td>18</td>
                        <td>17</td>
                        <td>15</td>
                      </tr>
                      <tr>
                        <td>재활용량</td>
                        <td>Ton</td>
                        <td>18</td>
                        <td>17</td>
                        <td>16</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="table_note">
                  ※ 당사는 재생에너지 구매 계약(REC·PPA·녹색프리미엄 등)을
                  보유하고 있지 않으며, Scope 2 간접 배출량은 지역기반으로
                  산정합니다.<br />
                  ※ 당사는 투자·운영 의사결정에 내부 탄소가격을 적용하고 있지
                  않습니다.<br />
                  ※ 당사는 경영진 성과평가·보상에 온실가스 감축 등 기후 관련
                  지표를 연계하고 있지 않습니다.<br />
                  ※ 당사는 현재 정량 감축 목표를 설정하지 않았으며, 따라서
                  목표의 수정 이력도 없습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- //company -->
      </div>
    </div>
    <Footer />
    <SummitControl />
  </div>
</template>

<script>
import Header from "../../components/Header";
import BreadCrumb from "../../components/BreadCrumb";
import Footer from "../../components/Footer";
import SummitControl from "../../components/SummitControl.vue";

export default {
  name: "EsgIntro",
  metaInfo: {
    title: "ESG 개요 | ESG 추진방향 | ESG",
  },
  components: {
    Header,
    BreadCrumb,
    Footer,
    SummitControl,
  },
  props: {},
  emits: [],
  data() {
    return {
      tabIndex: "1",
      isVisibleData: false,
      showPdf: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    tabActive(num) {
      this.tabIndex = num;
    },
    isVisibleFn() {
      this.isVisibleData = !this.isVisibleData;
      setTimeout(function () {
        let gPos = document.querySelector("#tabTarget").offsetTop,
          gH1 = document.querySelector("#header").offsetHeight,
          gH2 = document.querySelector(".location").offsetHeight,
          result = gPos - gH1 - gH2;

        if (document.documentElement.scrollTop || document.body.scrollTop) {
          document.documentElement.scrollTop = result;
        } else {
          document.querySelector("#wrap").scrollTop = result;
        }
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_type01 {
  border-top: 1px solid #dadada;
}
.esg {
  .esg_box {
    padding: 60px 0 20px;
    text-align: center;
    p {
      margin: 20px 0 0;
    }
    .table_type04 {
      margin-top: 20px;
      th,
      td {
        vertical-align: middle;
      }
    }
    .table_note {
      margin-top: 16px;
      font-size: 14px;
      line-height: 1.5;
      color: #666;
      text-align: left;
    }
    sub {
      font-size: 0.5em;
      vertical-align: sub;
    }
  }
  .cp_area.pb0 {
    padding-bottom: 0;
  }
  .ui-btn-wrap {
    gap: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
    .ui-btn {
      display: inline-block;
      padding: 0 44px;
      color: #fff;
      font-size: 24px;
      line-height: 61px;
      width: 306.125px;
      background-color: #e51937;
    }
  }
}

@media (max-width: 1023px) {
  .esg {
    .cp_box {
      padding: 0 20px;
    }
    .esg_box {
      padding: 30px 15px 10px;

      th,
      td {
        padding: 5px;
        font-size: 13px;
        line-height: 1.3;
      }
      sup {
        line-height: inherit;
      }
      .table_note {
        font-size: 12px;
      }
    }
    .scroll_area {
      overflow: scroll;
      .inner {
        width: 1120px;
      }
    }
    .ui-btn-wrap {
      gap: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      .ui-btn {
        padding: 0 22px;
        font-size: 16px;
        line-height: 40px;
        width: 185.094px;
      }
    }
  }
}
</style>
